export default __webpack_public_path__ + "static/media/Fancoil-units.66728844.png";